import { Injectable } from '@angular/core';
import { AxiosService } from './../../../core/axios';
import { NewChatDTO } from './../../../shared/dto/message-chat.dto';
import { environment } from './../../../../environments/environment';
import { ResponseCodeDTO } from 'src/app/shared/dto/response-codes.dto';

@Injectable({
  providedIn: 'root',
})
export class AssistantService {
  constructor(private axiosService: AxiosService) {
    // do nothing
  }

  // Métodos para el nuevo asistente virtual
  async createNewChat(chat: NewChatDTO): Promise<NewChatDTO> {
    const result: ResponseCodeDTO = await this.axiosService.post(`${environment.apiUrl}utilities/assistant/startConversation`, chat);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async sendNewMessage(messageData: any): Promise<NewChatDTO> {
    // Reestructurar el mensaje para que coincida con lo que espera el backend
    const formattedMessage = {
      conversation_id: messageData.conversation_id,
      message: {
        content: messageData.content,
        role: messageData.role,
        metadata: {
          source: 'fe-web',
          userAgent: navigator.userAgent,
          ip: messageData.ip || '',
        },
      },
      user_id: '',
    };

    const result: ResponseCodeDTO = await this.axiosService.post(`${environment.apiUrl}utilities/assistant/continueConversation`, formattedMessage);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }
}
